97
<script>
//TODO: centralize location, time and canteen settings!
import Modal from '@/components/atoms/Modal'
import RadioAddress from '@/components/molecules/input/RadioAddress'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import Spinner from '@/components/atoms/Spinner'
import Box from '@/components/atoms/Box'
import { Address } from '@/api'
import { mapGetters } from 'vuex'
import isEmpty from 'lodash.isempty'
import isEqual from 'lodash.isequal'
import { Query } from '@/modules/plugins/query'
import getAddress from '@/modules/mixins/getAddress'
import SpecifyLocation from '@/components/organism/location/SpecifyLocation'
import InputTextarea from '@/components/atoms/inputlib/components/InputTextarea'
import InputLocation from '@/components/atoms/inputlib/components/InputLocation'
import slideTransitions from '@/modules/mixins/slideTransitions'
import SortLocation from '@/components/organism/location/SortLocation.vue'

export default {
    name: 'ModalSelectLocation',

    components: {
        SortLocation,
        Box,
        ButtonLoader,
        RadioAddress,
        Modal,
        Spinner,
        InputLocation,
        SpecifyLocation,
        InputTextarea,
    },

    mixins: [getAddress, slideTransitions],

    data() {
        return {
            address: null,
            searchAddress: null,
            loading: false,
            showDetails: false,
            callback: null,
            allowanceBackup: null,
            error: null,
            state: 'select',
            isSortSaving: false,
            onlySortState: false,
        }
    },

    computed: {
        ...mapGetters({
            orderAddress: 'order/address',
            listView: 'site/listView',
            needToSetQuery: 'site/needToSetQuery',
            allowance: 'allowance',
            activeRestaurant: 'active/restaurant',
        }),
        isSelectState() {
            return this.state === 'select'
        },
        isSortState() {
            return this.state === 'sort'
        },
        isCheckout() {
            return this.$route.name === 'checkout'
        },
        selectedId() {
            return this.address?.model?.id
        },
        searchAddressValue: {
            get() {
                return this.searchAddress.model
            },
            set(model) {
                this.searchAddress.model = model
            },
        },
        hasSearchAddress() {
            return !isEmpty(this.searchAddress?.model)
        },
        hasAddress() {
            return !isEmpty(this.address?.model)
        },
        noAddress() {
            return !this.hasSearchAddress && !this.hasAddress
        },
        allowanceChanged() {
            return this.allowanceBackup?.id !== this.allowance?.id
        },
        scrollable() {
            return true
        },
    },

    methods: {
        async showOnlySortState() {
            this.state = 'sort'
            this.onlySortState = true
        },
        async showSortState() {
            await this.setSlideLeft()
            this.state = 'sort'
        },
        async showSelectState() {
            await this.setSlideRight()
            this.state = 'select'
        },
        async setAddress(address, closeModal = true, callback) {
            if (this.noAddress && !address) return
            if (this.hasSearchAddress) {
                this.$store.dispatch('order/setAddress', this.searchAddress.model)
                this.$user.getExpenseRules()
            } else if (this.hasAddress || address) {
                if (address) this.address = new Address(address)
                if (callback) this.callback = callback
                if (this.listView || this.allowanceChanged) {
                    await this.$store.dispatch('getDeliveryPeriod', {
                        restaurantId: this.activeRestaurant?.id,
                        allowanceId: this.allowance?.id,
                    })
                }
                if (
                    this.getId(this.$cart.address) === this.address?.id &&
                    isEqual(this.address.model, this.orderAddress) &&
                    closeModal
                ) {
                    try {
                        await this.$cart.calculate()
                    } finally {
                        if (this.allowanceChanged) await this.$cart.calculate()
                        this.setQueryInView()
                        this.close()
                    }
                    return
                }
                await this.verifyLegacyAddress()
                await this.$store.dispatch('order/setAddress', this.address?.model || {})
                this.$user.getExpenseRules()
                if (this.$route.name === 'checkout') {
                    this.$cart.setInvoice()
                    this.$cart.setPhone(this.$user.model, this.orderAddress)
                }
            }

            this.setQueryInView()
            try {
                await this.$cart.calculate()
            } finally {
                if (this.callback) this.callback()
                if (closeModal) this.close()
            }

            return
        },
        setQueryInView() {
            if (this.needToSetQuery) {
                this.setQuery(
                    Query.getLocationQuery(
                        this.hasSearchAddress ? this.searchAddress.model : this.address.model
                    )
                )
            }
        },
        async open(callback, error) {
            try {
                this.error = error
                this.searchAddress = new Address()
                this.address = new Address(this.orderAddress)
                this.loading = true
                this.callback = callback
                if (this.allowance)
                    this.allowanceBackup = JSON.parse(JSON.stringify(this.allowance))
                await this.$user.getExpenseRules()
                this.$refs.ModalSelectLocation.openModal()
            } finally {
                this.loading = false
            }
        },
        cancel() {
            if (
                (!this.allowanceBackup && this.allowance) ||
                this.allowanceBackup?.id !== this.allowance?.id
            )
                this.$store.dispatch('setAllowance', this.allowanceBackup)
            this.close()
        },
        close() {
            this.$refs.ModalSelectLocation.closeModal(true, true)
            this.address = null
            this.searchAddress = null
            this.allowanceBackup = null
            this.error = null
            this.showDetails = null
            if (this.callback) {
                this.callback()
                this.callback = null
            }
        },
        selectAddress(address) {
            if (!isEmpty(this.searchAddress?.model)) this.searchAddress = new Address()
            this.address.updateModel(address.model)
        },
        resetSelectedAddress() {
            if (!isEmpty(this.address?.model)) this.address = new Address()
        },
        onLocationSearch(address) {
            this.resetSelectedAddress()
            this.showDetails = !!address.premise
        },
        onLocationDrag(address) {
            this.resetSelectedAddress()
            this.searchAddress.sub_address = address.premise
        },
        addNew() {
            this.$location.add.open(undefined, undefined, true)
        },
        async verifyLegacyAddress() {
            // for older addresses
            // if the saved address doesn't have placeId, then get it from google and set (alongside with lat and lng)

            if (
                !!this.address?.id &&
                !this.address?.is_company_address &&
                !this.address?.place_id
            ) {
                this.loading = true
                const resultObj = await this.getAddress({
                    address: this.address.full_address,
                })
                this.address.place_id = resultObj.place_id
                this.address.latitude = resultObj.geometry.location.lat
                this.address.longitude = resultObj.geometry.location.lng
                this.address.original_latitude = resultObj.geometry.location.lat
                this.address.original_longitude = resultObj.geometry.location.lng
                await this.address.save()
                await this.$addresses.fetch()
                this.loading = false
            }
            return
        },
        edit(address) {
            this.$location.edit.open(address)
        },
        async saveSort() {
            this.isSortSaving = true
            await this.$refs.sort.save()
            await this.$addresses.fetch()
            this.isSortSaving = false

            this.cancelSortState()
        },
        cancelSortState() {
            if (this.onlySortState) {
                this.close()
            } else {
                this.showSelectState()
            }
        },
        closed() {
            this.state = 'select'
            this.onlySortState = false
        },
    },
}
</script>

<template lang="pug">
modal.select-location(ref="ModalSelectLocation" @closed="closed" @close="closed" closable :scroll="scrollable" scroll-id="deliveryLocationBody"  close-class="btn-white-primary")
    template(v-slot:header)
        .flex.flex-column
            .modal-header-text.text-center {{ isSelectState ? $t('details.where') : $t('details.address_sort_title') }}
            p.text-center.mb-0.text-danger.mt-2(v-if="error") {{ $t(error) }}
    template(v-slot:body)
        transition(name="fade")
            spinner.d-center(v-if="loading")
            div(v-else)
                transition(:name="slideAbsolute" mode="out-in")
                    div(v-if="isSelectState" key="select")
                        input-location.mb-4(
                            v-model="searchAddressValue"
                            @input="onLocationSearch"
                            :placeholder="$t('details.placeholder.address')"
                            required lg dropdown)
                        box(:value="showDetails" :class="{'h-100': hasAddress}" slim)
                            input-textarea(
                                v-model="searchAddressValue.sub_address"
                                validate="subAddress"
                                :maxHeight="150"
                                :max="255"
                                :placeholder="$t('details.placeholder.sub_address')"
                                live resize) {{$t('details.sub_address')}}
                        box(:value="hasSearchAddress" :class="{'h-100': hasSearchAddress}" slim)
                            specify-location(v-model="searchAddressValue" @change="onLocationDrag" ref="specifyLocation" :height="330" :tooltip="$t('maps.move_pin')" full-address)
                        .d-flex.justify-content-between
                            label {{ $t('details.or_select_saved') }}
                            .btn.btn-xs.btn-primary(@click="showSortState") {{ $t('details.address_sort')}}
                        radio-address(
                            v-for="(savedAddress, index) in $addresses.items"
                            :key="`existingAddress-${index}`"
                            :value="selectedId"
                            :address="savedAddress"
                            :class="{'mt-4': index}"
                            @input="selectAddress($addresses.items[index])"
                            @edit="edit(savedAddress.model)")
                        button.btn.btn-add(@click="addNew")
                            icon.mr-2.text-primary(icon="fa-solid fa-plus")
                            | {{ $t('details.new_address') }}
                    div(v-if="isSortState" key="sort")
                        sort-location(ref="sort" :addresses="$addresses.items")

                
    template(v-slot:footer)
        transition(:name="slideAbsolute" mode="out-in")
          .d-flex.align-items-center.flex-grow-1(v-if="isSelectState" key="select")
                button.btn.btn-secondary.btn-block.mr-2(@click="cancel"  :disabled="loading") {{$t('base.cancel')}}
                button-loader.btn.btn-primary.btn-block.mt-0(@click="setAddress" :disabled="loading || noAddress" inline) {{$t('details.set_address')}}
          .d-flex.align-items-center.flex-grow-1(v-else key="sort")
                button.btn.btn-secondary.btn-block.mr-2(@click="cancelSortState" key="sort") {{$t('base.cancel')}}
                button-loader.btn.btn-primary.btn-block.mt-0(@click="saveSort" :loading="isSortSaving" inline) {{$t('base.save')}}

</template>
